import React, {
  useContext,
} from 'react';
import {
  View, StyleSheet, Animated,
} from 'react-native';
import { TapGestureHandler, State } from 'react-native-gesture-handler';


import { useColors } from '../../contexts/theme';
import MultiSelectContext from '../../contexts/MultiSelect';


const styles = StyleSheet.create({
  indicator: {
    width: 20, height: 20, borderRadius: 10, borderWidth: 2, margin: 20,
  },
  multiSelectToggle: {
    position: 'absolute',
  },
});


const MultiSelector = ({
  item, multiSelectProgress, showMultiSelect, hidden,
}) => {
  const colors = useColors(),
        { isSelected, toggle } = useContext(MultiSelectContext),
        borderColor = showMultiSelect && !hidden ? colors.text : 'transparent',
        backgroundColor = isSelected(item.id) && !hidden ? colors.text : 'transparent',
        onHandlerStateChange = ({ nativeEvent }) => {
          if (nativeEvent.state === State.ACTIVE) {
            toggle(item.id);
          }
        };

  return (
    <TapGestureHandler
      maxDurationMs={200}
      onHandlerStateChange={onHandlerStateChange}
    >
      <Animated.View
        style={[
          styles.multiSelectToggle,
          {
            opacity: multiSelectProgress.current,
            transform: !item.isCalendarEvent ? [{
              translateX: multiSelectProgress.current.interpolate({
                inputRange: [0, 1],
                outputRange: [-70, 0],
              }),
            }] : [],
          },
        ]}
      >

        <View style={[styles.indicator, {
          borderColor,
          backgroundColor,
        }]}
        />

      </Animated.View>
    </TapGestureHandler>

  );
};

export default MultiSelector;
